import { useLocation } from "react-router-dom";
import Header from "./header";
import Side from "./side";
import styles from "../styles/_layouts/layout.module.scss";
import { paths } from "../routes/paths";

const Layout = ({ children }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <>
      <Header />
      <Side />
      <main
        className={styles.main}
        style={{ padding: path === paths.login ? "0px" : "90px 0px 0px 300px" }}
      >
        {children}
      </main>
    </>
  );
};

export default Layout;
